// removed by extract-text-webpack-plugin
module.exports = {"text":"Reason__text___kpACN","change-reason":"Reason__change-reason___h5ryS"};